import React, { useEffect, useState } from 'react';
import {
  fetchCategories,
  fetchProducts,
  fetchProductsByCategory,
} from '../api/api';
import { useNavigate } from 'react-router-dom';
import CartButton from '../components/CartButton'; // ✅ تأكد أن هذا المسار صحيح

function CategoriesWithProducts() {
  const [categories, setCategories] = useState([]);
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);
  const [products, setProducts] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    fetchCategories().then(setCategories);
    fetchProducts().then(setProducts);
  }, []);

  useEffect(() => {
    if (selectedCategoryId !== null) {
      fetchProductsByCategory(selectedCategoryId).then(setProducts);
    } else {
      fetchProducts().then(setProducts);
    }
  }, [selectedCategoryId]);

  const filteredProducts = products.filter((prod) =>
    prod.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div style={styles.container}>
      {/* Header with Logo, Search, and Cart */}
      <header style={styles.header}>
        {/* ✅ شعار المطعم */}
        <div style={styles.brandContainer}>
          <div style={styles.logoCircle}>🍴</div>
          <div style={styles.brandText}>
            <span style={styles.brandMain}>مطعم الأصالة</span>
          </div>
        </div>

        {/* حقل البحث */}
        <input
          type="text"
          placeholder="ابحث عن طبق..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={styles.searchInput}
        />

        {/* زر السلة */}
        <div style={styles.cartWrapper}>
          <CartButton />
        </div>
      </header>

      <h1 style={styles.title}>اكتشف قائمتنا</h1>
      <p style={styles.subtitle}>اختر الفئة واستمتع بتصفح نكهاتنا الشهية</p>

      <ul style={styles.categoryList}>
        {categories.map((cat) => (
          <li
            key={cat.id}
            onClick={() =>
              setSelectedCategoryId(
                selectedCategoryId === cat.id ? null : cat.id
              )
            }
            style={{
              ...styles.categoryCard,
              ...(selectedCategoryId === cat.id ? styles.categoryCardActive : {}),
            }}
          >
            {cat.image && (
              <img
                src={`https://al-asala-restaurant.com/api/storage/${cat.image}`}
                alt={cat.name}
                style={styles.categoryImage}
              />
            )}
            <div style={styles.categoryName}>{cat.name}</div>
          </li>
        ))}
      </ul>

      <hr style={styles.divider} />

      <h2 style={styles.sectionTitle}>🍔 أطباق مختارة</h2>

      {filteredProducts.length === 0 ? (
        <div style={styles.noProducts}>😕 لا يوجد أصناف تطابق بحثك</div>
      ) : (
        <ul style={styles.productList}>
          {filteredProducts.map((prod) => (
            <li
              key={prod.id}
              onClick={() => navigate(`/products/${prod.id}`)}
              style={styles.productCard}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'scale(1.03)';
                e.currentTarget.style.boxShadow = '0 10px 25px rgba(170, 84, 41, 0.2)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'scale(1)';
                e.currentTarget.style.boxShadow = '0 4px 14px rgba(0,0,0,0.1)';
              }}
            >
              {prod.image && (
                <div style={styles.imageContainer}>
                  <img
                    src={`https://al-asala-restaurant.com/api/storage/${prod.image}`}
                    alt={prod.name}
                    style={styles.productImage}
                  />
                </div>
              )}
              <div style={styles.productInfo}>
                <h3 style={styles.productName}>{prod.name}</h3>

                {prod.description && (
                  <p style={styles.productDescription}>
                    {prod.description.length > 50
                      ? prod.description.slice(0, 50) + "..."
                      : prod.description}
                  </p>
                )}

                <span style={styles.productPrice}>💰 {prod.price} ₪</span>
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    navigate(`/products/${prod.id}`);
                  }}
                  style={styles.viewButton}
                >
                  👁️ تفاصيل
                </button>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

const styles = {
  container: {
    fontFamily: "'Cairo', sans-serif",
    padding: '16px',
    backgroundColor: '#FCE9D6',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    justifyContent: 'space-between',
    padding: '10px 16px',
    backgroundColor: '#FFE7C6',
    borderRadius: '12px',
    marginBottom: '24px',
    boxShadow: '0px 3px 8px rgba(0, 0, 0, 0.05)',
  },
  brandContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  logoCircle: {
    width: '42px',
    height: '42px',
    background: 'linear-gradient(135deg, #A63A24, #E36D41)',
    borderRadius: '50%',
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '20px',
    boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
  },
  brandText: {
    display: 'flex',
    flexDirection: 'column',
    lineHeight: '1.1',
  },
  brandMain: {
    fontWeight: '700',
    fontSize: '18px',
    color: '#A63A24',
  },
  brandSub: {
    fontSize: '12px',
    color: '#8b5b3f',
  },
  searchInput: {
    flex: 1,
    padding: '8px 14px',
    borderRadius: '8px',
    border: '1px solid #d2bca9',
    fontSize: '14px',
    backgroundColor: '#fff',
    outline: 'none',
    margin: '0 8px',
  },
  cartWrapper: {
    minWidth: '44px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  title: {
    fontSize: '26px',
    fontWeight: '700',
    color: '#A63A24',
    textAlign: 'center',
    marginBottom: '8px',
  },
  subtitle: {
    fontSize: '14px',
    color: '#81614B',
    textAlign: 'center',
    marginBottom: '24px',
  },
  categoryList: {
    display: 'flex',
    gap: '12px',
    overflowX: 'auto',
    listStyle: 'none',
    padding: 0,
    marginBottom: '24px',
  },
  categoryCard: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '8px 14px',
    cursor: 'pointer',
    borderRadius: '22px',
    border: '1px solid #d8c1ae',
    background: '#fff8f1',
    transition: 'all .25s ease',
    whiteSpace: 'nowrap',
  },
  categoryCardActive: {
    border: '2px solid #FF9659',
    background: '#FFF1E3',
  },
  categoryName: {
    fontSize: '14px',
    fontWeight: '600',
    color: '#A63A24',
  },
  categoryImage: {
    width: '34px',
    height: '34px',
    objectFit: 'cover',
    borderRadius: '50%',
    border: '2px solid #ffffff',
  },
  divider: {
    margin: '16px 0',
    borderColor: '#e2d2c3',
  },
  sectionTitle: {
    fontSize: '22px',
    fontWeight: '600',
    color: '#A63A24',
    textAlign: 'center',
    marginBottom: '18px',
  },
  noProducts: {
    textAlign: 'center',
    color: '#b08267',
  },
  productList: {
    listStyle: 'none',
    padding: 0,
    display: 'grid',
    gap: '18px',
    gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 1fr))',
  },
  productCard: {
    cursor: 'pointer',
    border: '1px solid #efd1bb',
    borderRadius: '16px',
    backgroundColor: '#FFF8F5',
    boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
    padding: '12px',
    transition: 'all .25s',
  },
  imageContainer: {
    textAlign: 'center',
  },
  productImage: {
    width: '110px',
    height: '110px',
    objectFit: 'cover',
    borderRadius: '14px',
    marginBottom: '14px',
    boxShadow: '0 2px 10px rgba(0,0,0,0.12)',
  },
  productInfo: {
    textAlign: 'center',
  },
  productName: {
    fontSize: '15px',
    fontWeight: '700',
    color: '#2F2F2F',
  },
  productDescription: {
    fontSize: '13px',
    color: '#6d5c53',
    margin: '6px 0 8px',
    lineHeight: '1.4',
  },
  productPrice: {
    color: '#FF7F3F',
    fontWeight: '600',
    fontSize: '14px',
    margin: '6px 0',
  },
  viewButton: {
    backgroundColor: '#FF9659',
    color: '#ffffff',
    padding: '6px 12px',
    borderRadius: '8px',
    border: 'none',
    fontSize: '13px',
    cursor: 'pointer',
    width: '100%',
  },
};

export default CategoriesWithProducts;
